<app-dot-loader [page]="true"></app-dot-loader>
